import { CbBorderRadius100, CbColorPrimitiveGreenFreshgreen, CbColorPrimitiveGreenPeppermint, } from '@coolblue-development/design-tokens';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const fadeInOverlay = keyframes `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
export const Confirmation = styled.div `
  display: inline-flex;
  align-items: center;
  background: ${CbColorPrimitiveGreenPeppermint};
  border-radius: ${CbBorderRadius100};
  border: solid 1px ${CbColorPrimitiveGreenFreshgreen};
  padding: 11px 14px;
  margin-top: 1px;
  animation: ${fadeInOverlay} 0.2s ease-in-out forwards;
`;
export const AnimatedButton = styled.button `
  animation: ${fadeInOverlay} 0.2s ease-in-out forwards;

  .plus-icon {
    width: 1.2rem;
    height: 1.2rem;
  }

  .cart-icon {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
//# sourceMappingURL=AddToCartButton.styled.js.map